'use client';
import 'blaze-slider/dist/blaze.css';
import Image from 'next/image';
import useBlazeSlider from '@/utils/useBlazeSlider';
import { resolveImageAltText } from '@/lib/utils';

export default function CardsSlider({ block, position }) {
  const {
    title,
    _metadata,
    description,
    background_color,
    text_color,
    dots_arrows_color,
    cards
  } = block.cards_slider;
  return (
    <section
      id={_metadata.uid + '_' + position}
      data-name="cards-slider"
      className={`cards-slider py-20 sm:py-30 bg-[${background_color}]`}
    >
      <div
        className={`mb-15 text-[${text_color}] relative mx-auto max-w-270 px-5 sm:px-15 min-[71.25rem]:px-5`}
      >
        <h2 className="h3 lg:h2 mb-4 text-center">{title}</h2>
        <div className="body-l text-center">{description}</div>
      </div>
      <Slider cards={cards} dots_arrows_color={dots_arrows_color} />
    </section>
  );
}

function Slider({ cards, dots_arrows_color }) {
  const elRef = useBlazeSlider({
    all: {
      slidesToShow: 3,
      slideGap: '20px'
    },
    '(max-width: 1023px)': {
      slidesToShow: 1
    },
    '(max-width: 639px)': {
      slidesToShow: 1
    }
  });

  return (
    <div
      className="blaze-slider relative mx-auto max-w-270 pr-0 pl-5 sm:pr-0 sm:pl-15 lg:px-11.25 min-[71.25rem]:pr-5 min-[71.25rem]:pl-4"
      ref={elRef}
    >
      <div className="blaze-container lg:flex">
        {cards.length > 3 && (
          <button className="blaze-prev absolute -left-11.25 hidden h-7 w-7 self-center bg-black mask-contain lg:block">
            <span className="sr-only">previous</span>
          </button>
        )}
        <div className="blaze-track-container flex w-full max-w-260 overflow-x-hidden">
          <div className={`blaze-track w-70 lg:w-full`} tabIndex={0}>
            {cards.map((card, index) => {
              return (
                <div
                  className="text-parlor-green w-70 bg-white lg:w-full"
                  key={index}
                >
                  {card?.icon?.url && (
                    <div
                      className={`bg-parlor-green-20 relative flex h-21 px-5 py-2`}
                    >
                      <Image
                        src={card.icon.url}
                        alt={resolveImageAltText(card)}
                        width="64"
                        height="64"
                        sizes="64px"
                        className="max-h-16 self-center"
                      />
                    </div>
                  )}
                  <div className="min-h-56 p-5">
                    <h3 className="sh10 mb-3">{card.title}</h3>
                    <div className="body-r">{card.description}</div>
                    {card?.attribution && (
                      <h4 className="sh11 mt-3">{card.attribution}</h4>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {cards.length > 3 && (
          <button className="blaze-next absolute -right-11.25 hidden h-7 w-7 self-center bg-black mask-contain lg:block">
            <span className="sr-only">next</span>
          </button>
        )}
      </div>
      <div
        className={`blaze-pagination mt-10 flex ${dots_arrows_color == 'Dark' ? 'indicators-dark' : 'indicators-light'}`}
      ></div>
    </div>
  );
}
